import { render, staticRenderFns } from "./reporttipsvistacoronadetail.vue?vue&type=template&id=61de173f"
import script from "./reporttipsvistacoronadetail.vue?vue&type=script&lang=js"
export * from "./reporttipsvistacoronadetail.vue?vue&type=script&lang=js"
import style0 from "./reporttipsvistacoronadetail.vue?vue&type=style&index=0&id=61de173f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports